import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'
import PaginatedListSearchField from '../common/PaginatedListSearchField.js'
import { useLocation } from 'react-router-dom'
import { PRESUPUESTADOR_ENDPOINT } from 'cfgCommon/endpoints'
import { NotFound } from '../vista-vendedor/NavVendedor'
import ChipsList from "../common/ChipsList"
import ReactSelect from 'react-select';
import MultiSelect from 'simulador-financiero/MultiSelect'
import DatePicker from '../common/DatePicker.js'
import { Button, Popover } from '@material-ui/core'
import * as Colors from '../../common/colors'
import { useAsyncFunc } from '../common/hooks'
import { BFFAgent } from 'BFFAgent'
import { getMultiSelectQuery } from 'Utilities'
import moment from 'moment'
import DropdownComponent from 'common/Dropdown/DropdownComponent.js'
import * as actions from './redux/actions'

const selectStyle = {
  placeholder: (styles) => ({
    ...styles,
    color: '#989898',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '19px',
    marginLeft: '0px',
  }),
  singleValue: (styles, state) => ({
    ...styles,
    color: '#333',
    fontWeight: state.hasValue ? 500 : 400,
  }),
  control: (styles, state) => ({
    ...styles,
    borderColor: state.isFocused ? Colors.COLOR_PRIMARIO : styles.borderColor,
    boxShadow: state.isFocused ? '0 0 0 1px ' + Colors.COLOR_PRIMARIO : styles.boxShadow,
    '&:hover': {
      borderColor: state.isFocused ? Colors.COLOR_PRIMARIO : styles['&:hover'].borderColor,
    },
  }),
}

const entregaUsado = [
  {value: "true", label: 'Con entrega usado/s'},
  {value: "false", label: 'Sin entrega usado/s'}
]

const financiacion = [
  {value: "true", label: 'Con financiación'},
  {value: "false", label: 'Sin financiación'}
]

const estado = [
  {value: 'Generado', label: 'Generado'},
  {value: 'Cerrado', label: 'Cerrado'},
  {value: 'Reservado', label: 'Reservado'},
  {value: 'Anulado', label: 'Anulado'}
]

const tipoVenta = [
  {value: 'Directa', label: 'Directa'},
  {value: 'Convencional', label: 'Convencional'},
  {value: 'Usado', label: 'Usado'}
]

const dateList = [
  { label: 'Hoy', name: 'hoy' },
  { label: 'Ayer', name: 'ayer' },
  { label: 'Últimos 7 días', name: '7dias' },
  { label: 'Últimos 30 días', name: '30dias' },
  { label: 'Este mes', name: 'este-mes' },
  { label: 'Mes pasado', name: 'mes-pasado' }
]

const createdBy = [
  {value: 'client', label: 'Cliente'},
  {value: 'business_advisor', label: 'Asesor comercial'},
  {value: 'resale', label: 'Reventa'},
  {value: 'carmuv_admin', label: 'Admin. Carmuv'},
  {value: 'web_catalog', label: 'Catálogo web'},
]

// TODO: unificar manejo de fechas
// FIXME: esto se ve innecesariamente complejo y una fuente de bugs.
// usar una librería como moment.js o date-fns

export function getDate(value) {
  //HOY
  const today = moment().format('YYYY-MM-DD')
  
  switch(value){//Los valores deben ir desde la fecha mas vieja a la más actual
    /* eslint-disable no-case-declarations */
    
    case 'hoy': //quiero ver hoy
    return [today, today] 
    
    case 'ayer': //quiero ver ayer
    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')
    return [yesterday, yesterday]
    
    case '7dias': //hace 7 dias
      const sevenDays = moment().subtract(7, 'days').format('YYYY-MM-DD')
      return [sevenDays, today]

    case '30dias': //hace 30 dias, o sea, entre 30 dias atras y hoy.
      const thirtyDays = moment().subtract(30, 'days').format('YYYY-MM-DD')
      return [thirtyDays, today]

    case 'este-mes': // de 01 a último día del mes actual
      const startOfMonth = moment().startOf('month').format('YYYY-MM-DD')
      const endOfMonth = moment().endOf('month').format('YYYY-MM-DD')
      return [startOfMonth, endOfMonth]

    case 'mes-pasado':
      const nextStartOfMonth = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
      const nextEndOfMonth = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
      return [nextStartOfMonth, nextEndOfMonth]

    default:
      return //do nothing
  }
}

// se usa estado interno dado que para el react select necesitamos id y label
// en el querystring solo está el id.
// o se coloca toda la info en el querystring y se filta al enviar al backend
// o se usa estado interno. en este caso se elige usar el estado interno
// @see checkExistingValue() en AsyncSelect.js para inicialización
const labelOptions = (options) => options.map((option) => [option, option ? option.replace(/ ,;/g, '_').toUpperCase() : null])

// Genera el texto de manera dinamica para poder usarse en el componente MultiSelect
const generateMultiSelectPlaceHolder = (items, selectedItems) => {
  const onlyOneItem = selectedItems?.length === 1

  return onlyOneItem
    ? items.find(item => item.value === selectedItems[0])?.label || ''
    : `${selectedItems?.length} seleccionados`
}

const SchemaFilters = ({
  item,
  key,
  onChangeFilters,
  data,
  desde,
  onChangeDateDesde,
  hasta,
  onChangeDateHasta,
  // closeFilterDate,
  filterDays,
  filterCustomDate,
  showCommercialAdvisor,
  anchorEl,
  open,
  idSelectDate,
  handleCloseFilter,
  handleOpenFilter,
  openCustomDate,
  handleOpenCustomDate,
  placeholderBranchOffice,
  branchOfficeOptions,
  branchOfficeSelected,
  branchOfficeChange,
  businessAdvisorOptions,
}) => {
  if (item.dataField === 'state' && item.show) {
    return (
      <div className="div-filter-select" key={key}>
        <ReactSelect
          styles={selectStyle}
          name={item.text}
          options={estado}
          isSearchable={false}
          value={data?.value ? data.value : item.text}
          placeholder={data?.value ? data.value : item.text}
          onChange={e => onChangeFilters({ name: item.dataField, value: {label: e.value, value: e.label} })}
        />
      </div>
    )
  } else if (item.dataField === 'sale_type' && item.show) {
    return (
      <div className="div-filter-select" key={key}>
        <ReactSelect
          styles={selectStyle}
          name={item.text}
          options={tipoVenta}
          isSearchable={false}
          value={data?.value ? data.value : item.text}
          placeholder={data?.value ? data.value : item.text}
          onChange={e => onChangeFilters({ name: item.dataField, value: {label: e.value, value: e.label} })}
        />
      </div>
    )
  }  else if (item.dataField === 'branch_office_id' && item.show) {
    return (
      <div className="div-filter-select" key={key}>
        <MultiSelect
          options={branchOfficeOptions}
          name="branch_office_id"
          selected={branchOfficeSelected}
          onChange={branchOfficeChange}
          isDisabled={(!branchOfficeOptions.length || branchOfficeOptions.length === 1)}
          placeholder={placeholderBranchOffice}
        />
      </div>
    )
  } else if (item.dataField === 'credit_line_avg_fees' && item.show) {
    return (
      <div className="div-filter-select" key={key}>
        <ReactSelect
          styles={selectStyle}
          name={item.text}
          options={financiacion}
          isSearchable={false}
          value={data?.value ? data.value : item.text}
          placeholder={data?.label ? data.label : item.text}
          onChange={e => onChangeFilters({ name: item.dataField, value: {label: e.label, value: e.value} })}
        />
      </div>
    )
  } else if (item.dataField === 'taking_car' && item.show) {
    return (
      <div className="div-filter-select" key={key}>
        <ReactSelect
          styles={selectStyle}
          name={item.text}
          options={entregaUsado}
          isSearchable={false}
          value={data?.value ? data.value : item.text}
          placeholder={data?.label ? data.label : item.text}
          onChange={e => onChangeFilters({ name: item.dataField, value: {label: e.label, value: e.value} })}
        />
      </div>
    )
  }else if(showCommercialAdvisor && item.dataField === 'user_name' && item.show){ 
    return (
      <div className="div-filter-select" key={key}>
        <ReactSelect
          styles={selectStyle}
          name={item.text}
          isSearchable={false}
          value={data?.value ? data.value : item.text}
          placeholder={data?.value ? data.value : item.text}
          options={businessAdvisorOptions}
          onChange={e => onChangeFilters({ name: item.dataField, value: {label: e.value, value: e.label} })}
        />
      </div>
    )
  } else if(item.type === 'date' && item.show){
    return(
      <div className="date-filter div-filter-select" key={key}>
        <div>
          <Button className="w-100 d-flex justify-content-between" id="buttonFilterDateStyle" color="inherit" size="small" onClick={handleOpenFilter}>
            <span style={{fontWeight: '400'}}>Fecha</span>
            <i className="material-icons chevron-date">expand_more</i>
          </Button>
          <Popover
            className="cont-date-collapse"
            id={idSelectDate}
            open={open}
            anchorEl={anchorEl}
            onClose={handleCloseFilter}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            PaperProps={{
              style: {
                  minWidth: '12rem',
                  maxWidth: '12rem',
                  marginTop: '8px'
              },
            }}
          >
            <div className="panel-group select-filtros">
              <div className="panel panel-default">
                {
                  dateList.map(dateListItem => (
                    <div key={dateListItem.name} className="date-item" name={dateListItem.name} onClick={e => filterDays(e)}>
                      <span name={dateListItem.name}>{dateListItem.label}</span>
                    </div>
                  ))
                }
                <button className={`date-item custom-date-btn ${openCustomDate && 'active'}`} onClick={handleOpenCustomDate}>
                  <span className="filter-section" name="option3-1">Fecha personalizada</span>
                  <i className="material-icons chevron-date">{openCustomDate ? 'expand_less' : 'expand_more'}</i>
                </button>
                {openCustomDate && 
                  <div className="date-item-custom">
                    <DatePicker
                      label="Desde"
                      value={desde}
                      onChange={onChangeDateDesde}
                    />
                    <DatePicker
                      label="Hasta"
                      value={hasta}
                      minDate={desde}
                      onChange={onChangeDateHasta}
                    />
                    <div className="d-flex mt-2">
                      <Button 
                        disableElevation 
                        size="small" 
                        color="primary" 
                        variant="contained" 
                        onClick={filterCustomDate}>
                        Buscar
                      </Button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </Popover>
        </div>
      </div>
    )
  } else if(item.dataField === 'created_by' && item.show) {
    return (
      <div className="div-filter-select" key={key}>
        <DropdownComponent 
          name={item.text}
          values={[data]}
          placeholder={data?.label ? data.label : item.text}
          onChange={value => {
            onChangeFilters({
              name: item.dataField,
              value
            })
          }}
          dropdownOptions={createdBy}
          showClearIcon={false}
        />
      </div>
    )
  }
  return null
} 

function FilterControls({ 
  onChangeFiltros,
  defaultFilters, 
  setFiltersApplied, 
  filtersApplied, 
  filters,
  showCommercialAdvisor,
  anchorEl,
  open,
  idSelectDate,
  handleCloseFilter,
  handleOpenFilter,
  openCustomDate,
  handleOpenCustomDate,
  searchQueryParam,
  businessAdvisorOptions,
  setBusinessAdvisorOptions,
 }) {
  
  const location = useLocation()

  const getCarlots = state =>{
    return state?.common?.user?.license?.company?.Car_lots?.map(carlot =>({value:carlot.id, label:carlot.name, default:carlot.default})) || []  
  } 
  
  const getDefaultCarlot = (state) => getCarlots(state)?.find(carlot => carlot.default) || {}

  const carlotOptions  = useSelector(getCarlots)
  const carlotDefault = useSelector(getDefaultCarlot)
  const carlotsSelected = Array.isArray(filtersApplied.car_lot_id) ? filtersApplied.car_lot_id : [carlotDefault.value]

  const [branchOfficeOptions, setBranchOfficeOptions]  = useState([])

  const dispatch = useDispatch()
  
  const branchOfficeSelected = Array.isArray(filtersApplied["branch_office_id[]"]) ? filtersApplied["branch_office_id[]"] : []
  const placeholderCarlot = generateMultiSelectPlaceHolder(carlotOptions, carlotsSelected)
  const placeholderBranchOffice = branchOfficeSelected?.length ? (branchOfficeSelected.length > 1 ? `${branchOfficeSelected?.length} seleccionados` : branchOfficeSelected[0].label) : 'Sucursal'

  const [getBranchOffices] = useAsyncFunc( async (carLots) => {
    const response = await BFFAgent.Presupuestador.getBranchOffices(carLots);
    const branchOfficeList = response.filter(d => d.label)
    setBranchOfficeOptions(branchOfficeList)
  })

  useEffect(()=>{
    if(carlotsSelected.length) {
      getBranchOffices(carlotsSelected)
    }
  }, [carlotsSelected])

  // Mismo criterio que solicitud-venta (NavSolicitudList): opciones en estado, refetch al cambiar concesionario.
  useEffect(() => {
    if (!showCommercialAdvisor) {
      setBusinessAdvisorOptions([])
      return
    }
    const carLotId = filters?.car_lot_id
    if (!carLotId) {
      setBusinessAdvisorOptions([{ value: '', label: 'Sin resultados' }])
      return
    }
    let cancelled = false
    axios
      .get(
        `${PRESUPUESTADOR_ENDPOINT}/businessAdvisors/?car_lot_id=${encodeURIComponent(
          carLotId,
        )}`,
      )
      .then((res) => {
        if (cancelled) return
        const data = res.data?.data ?? []
        const opts = data.length
          ? data.map((obj) => ({
              value: obj.user_name,
              label: obj.user_name,
            }))
          : [{ value: '', label: 'Sin resultados' }]
        setBusinessAdvisorOptions(opts)
      })
      .catch((err) => {
        if (cancelled) return
        console.error(err)
        setBusinessAdvisorOptions([{ value: '', label: 'Sin resultados' }])
      })
    return () => {
      cancelled = true
    }
  }, [filters?.car_lot_id, showCommercialAdvisor, setBusinessAdvisorOptions])

  useEffect( () => {
    dispatch(actions.setBranchOfficeList(branchOfficeOptions))
    const urlParams = new URLSearchParams(location.search)
    const branchOfficeId = urlParams.getAll('branch_office_id[]')
    const created_by = urlParams.get('created_by')
    const taking_car = urlParams.get('taking_car')
    const credit_line_avg_fees = urlParams.get('credit_line_avg_fees')
    const ls = branchOfficeOptions.filter( f => branchOfficeId.includes(f.id[0]))
    const ls2 = createdBy.filter( f => f.value === created_by)
    const ls3 = entregaUsado.filter( f => f.value === taking_car)
    const ls4 = financiacion.filter( f => f.value === credit_line_avg_fees)
    filtersApplied && setFiltersApplied({
      ...filtersApplied,
      ["branch_office_id[]"]: ls,
      created_by: ls2[0],
      taking_car: ls3[0],
      credit_line_avg_fees: ls4[0]
    })
  }, [branchOfficeOptions])
  
  // actualizar los endpoints de marca y modelo de acuerdo a los car_lots
  useEffect(()=>{
    
    const locationCarLots = new URLSearchParams(location.search).getAll(
      'car_lot_id'
    )
    if(locationCarLots?.length > 0) {
      const carLotsArray = locationCarLots[0].split(',')
      setFiltersApplied({...filtersApplied, car_lot_id: carLotsArray})
    }
  }, [location])

  const onChangeFilters = ({name, value}) => {
    const typeValues = value?.value ? value?.value : value
    setFiltersApplied({...filtersApplied, [name]: value})
    onChangeFiltros({ name: name, value: typeValues || '' })
  }

  const handleCarlotChange = (value, checked) =>{
    let newCarlots = [...carlotsSelected]
    if(checked){
      // Si es un item nuevo lo agrega al final
      newCarlots.push(value)
    } else if(carlotsSelected.length > 1) {
      // Se agrega la condición del if ya que no puede quedar el combo sin elementos
      newCarlots = newCarlots.filter(carlotId => carlotId !== value)
    }
    // Logica que actualiza los filtros
    setFiltersApplied({
      ...filtersApplied,
      car_lot_id: newCarlots,
    })
    // Logica que actualiza la tabla
    onChangeFiltros({
      name: 'car_lot_id',
      value: newCarlots.join(',')
    })
  }

  const branchOfficeChange = (value, checked) =>{
    let newBranchOffices = []
    const branchOfficeSelect = branchOfficeOptions.find(item => item.value === value)

    if(checked){
      // Si es un item nuevo lo agrega al final
      newBranchOffices = [...branchOfficeSelected, branchOfficeSelect]
    } else if(branchOfficeSelected?.length > 1) {
      // Se agrega la condición del if ya que no puede quedar el combo sin elementos
      newBranchOffices = branchOfficeSelected.filter(item => item.value !== value)
    }

    // Logica que actualiza los filtros
    setFiltersApplied({
      ...filtersApplied,
      ["branch_office_id[]"]: newBranchOffices,
    })

    // Logica que actualiza la tabla
    onChangeFiltros({
      name: 'branch_office_id[]',
      value: getMultiSelectQuery(newBranchOffices, 'branch_office_id[]')
    })
  }

  const [desde, setDesde] = useState(null)
  const onChangeDateDesde = (date) => {
    setDesde(date && new Date(date))
  }

  const [hasta, setHasta] = useState(null)
  const onChangeDateHasta = (date) => {
    setHasta(date && new Date(date))
  }

  useEffect(() => {
    if (!filtersApplied.query_date) {
      setDesde(null)
      setHasta(null)
    }
  }, [filtersApplied])
  
  const filterCustomDate = () => {
    if (!desde || !hasta) return
    if(hasta >= desde){
      const desdeDate = moment(desde).format('DD/MM/YYYY')
      const hastaDate = moment(hasta).format('DD/MM/YYYY')
      const query_date = `${desdeDate} - ${hastaDate}`
      setFiltersApplied({ ...filtersApplied, query_date })
      onChangeFiltros({ query_date })
    }else{
      alert('Revise las fechas ingresadas y el orden de las mismas.')
    }
  }

  const closeFilterDate = () => {
    window.$('#dateFilter').collapse('hide');
  }

  const filterDays = (event) => {
    const filter = event.target.getAttribute('name')
    setFiltersApplied({ ...filtersApplied, query_date: filter })
    onChangeFiltros({ query_date: filter })
  }
 
  return (
    <div className="common-filtros-card">
          <div className="div-filter-select">
            <MultiSelect
              options={carlotOptions}
              name="concesionaria"
              selected={carlotsSelected}
              onChange={handleCarlotChange}
              isDisabled={(!carlotOptions.length || carlotOptions.length === 1)}
              placeholder={placeholderCarlot}
            />
          </div>
        {defaultFilters.map( (item, key) => {

          const data = filtersApplied[item.dataField]
          
          return (
            <SchemaFilters
              item={item}
              key={key}
              onChangeFilters={onChangeFilters}
              data={data}
              labelOptions={labelOptions}
              desde={desde}
              onChangeDateDesde={onChangeDateDesde}
              hasta={hasta}
              onChangeDateHasta={onChangeDateHasta}
              closeFilterDate={closeFilterDate}
              filterDays={filterDays}
              filterCustomDate={filterCustomDate}
              showCommercialAdvisor={showCommercialAdvisor}
              anchorEl={anchorEl}
              open={open}
              idSelectDate={idSelectDate}
              handleCloseFilter={handleCloseFilter}
              handleOpenFilter={handleOpenFilter}
              openCustomDate={openCustomDate}
              handleOpenCustomDate={handleOpenCustomDate}
              placeholderBranchOffice={placeholderBranchOffice}
              branchOfficeOptions={branchOfficeOptions}
              branchOfficeSelected={branchOfficeSelected?.map(branchItem => branchItem?.value)}
              branchOfficeChange={branchOfficeChange}
              businessAdvisorOptions={businessAdvisorOptions}
            />
          )
        })}

      <PaginatedListSearchField
        setValue={onChangeFiltros}
        searchQueryParam={searchQueryParam}
        placeholder="Buscar..."
      />
    </div>
  )
}

// Función que trasnforma los filtros en un objeto valido para ChipList
const buildChipFilters = (filtersApplied, carLots, branchOfficeOptions) => {
  const newFilters = { ...filtersApplied }

  // Tratamiento para car_lot_id
  const carLotIds = filtersApplied['car_lot_id']
  if (carLotIds && Array.isArray(carLotIds)) {
    // Recorro el array de ids y mapeo dichos valores con su
    // correspondiente label
    const onlyOneChip = carLotIds.length === 1
    
    const carLotChips = carLotIds.map(id => {
      const carLotFromArray = carLots.find(carLot => carLot.id === id)
      return { label:carLotFromArray.name, value: carLotFromArray.id, readOnly: onlyOneChip }
   })

    newFilters['car_lot_id'] = carLotChips
  }

  if (typeof filtersApplied?.created_by !== 'object' ) {
    newFilters['created_by'] = createdBy.find(item => item.value === filtersApplied.created_by)
  }

  if (typeof filtersApplied?.credit_line_avg_fees !== 'object') {
    newFilters['credit_line_avg_fees'] = financiacion.find(item => item.value === filtersApplied.credit_line_avg_fees)
  }

  if (typeof filtersApplied?.taking_car !== 'object') {
    newFilters['taking_car'] = entregaUsado.find(item => item.value === filtersApplied.taking_car)
  }

  if (typeof filtersApplied['branch_office_id[]'] === 'string' && branchOfficeOptions && branchOfficeOptions.length) {
    const branchData = branchOfficeOptions.filter(f => filtersApplied['branch_office_id[]'] === f.id[0])
    newFilters['branch_office_id[]'] = branchData
  }

  if (filtersApplied['branch_office_id[]'] && filtersApplied['branch_office_id[]'] === 'string' || Array.isArray(filtersApplied['branch_office_id[]']) && !filtersApplied['branch_office_id[]'][0]?.label && branchOfficeOptions && branchOfficeOptions.length) {
    const branchOfficeIds = filtersApplied['branch_office_id[]']
    const list = branchOfficeOptions.filter(f => branchOfficeIds.some(id => id === f.id[0]))
    newFilters['branch_office_id[]'] = list
  }
  return newFilters
}

export default function NavBarListaCatalogo({
  onChangeFiltros,
  filters,
  searchQueryParam,
  children,
  wordsNotFound,
  defaultFilters,
  showCommercialAdvisor,
  marginTable
}) {
  
  const [filtersApplied, setFiltersApplied] = useState(filters)
  const [businessAdvisorOptions, setBusinessAdvisorOptions] = useState([])

  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpenFilter = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseFilter = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const idSelectDate = open ? 'simple-popover-filter-date' : undefined

  const [openCustomDate, setOpenCustomDate] = useState(false)

  const handleOpenCustomDate = () => {
    setOpenCustomDate(!openCustomDate)
  }
  const carLots = useSelector(
    state => state.common.user?.license?.company?.Car_lots || [],
  )
  const branchOfficeOptions = useSelector(state => state.presupuestador?.branchOfficeList)

  const chipFilters = buildChipFilters(filtersApplied, carLots, branchOfficeOptions)

  const handleOnChipDelete = ({name, value}) => {
    const newFilters = {...filtersApplied}
    let filterDeleted = newFilters[name] 
    if(filterDeleted && Array.isArray(filterDeleted)){
     
      if(name === "branch_office_id[]") {
        filterDeleted = filterDeleted.filter(filter => filter.value !== value)
        setFiltersApplied({...filtersApplied, [name]: filterDeleted})
        onChangeFiltros({ name: name, value: getMultiSelectQuery(filterDeleted, 'branch_office_id[]') })
        
      } else {
        filterDeleted = filterDeleted.filter(filter => filter !== value)
        const branch_office_id_selected = newFilters["branch_office_id[]"]
        if(branch_office_id_selected?.length) {
          //BORRADO DE BRANCH_OFFICE CUANDO NO COINCIDE CON LOS CAR_LOTS
          let branchOfficeFilter = branch_office_id_selected.filter(item => item.carLotIds.some(carLot => filterDeleted.some(filterCarLot => carLot === filterCarLot)))
          
          setFiltersApplied({...filtersApplied, "branch_office_id[]": branchOfficeFilter, [name]: filterDeleted})
          onChangeFiltros({ ["branch_office_id[]"]: getMultiSelectQuery(branchOfficeFilter, 'branch_office_id[]'), [name]: filterDeleted?.join(',') })
        } else {
          setFiltersApplied({...filtersApplied, [name]: filterDeleted})
          onChangeFiltros({ name: name, value: filterDeleted?.join(',') })
        }

      }
    } else {
      setFiltersApplied({...filtersApplied, [name]:null})
      onChangeFiltros({ name: name, value: null })
    }
  }

  return (
    <div className="common-nav-filtros nav-budgetlist" style={{margin: marginTable}}>
      <nav className="navbar navbar-light nav-bar-budget">
        <FilterControls
          className="filter-controls"
          onChangeFiltros={onChangeFiltros}
          defaultFilters={defaultFilters}
          filtersApplied={filtersApplied}
          setFiltersApplied={setFiltersApplied}
          filters={filters}
          showCommercialAdvisor={showCommercialAdvisor}
          anchorEl={anchorEl}
          open={open}
          idSelectDate={idSelectDate}
          handleCloseFilter={handleCloseFilter}
          handleOpenFilter={handleOpenFilter}
          openCustomDate={openCustomDate}
          handleOpenCustomDate={handleOpenCustomDate}
          searchQueryParam={searchQueryParam}
          businessAdvisorOptions={businessAdvisorOptions}
          setBusinessAdvisorOptions={setBusinessAdvisorOptions}
        />

      {children}
      </nav>
      <div className="resultados d-flex justify-content-between">
        <div className="container-resultados">
         <ChipsList
            filters={chipFilters}
            onChipDelete={handleOnChipDelete}
          />
        </div>
        <NotFound items={wordsNotFound} />
      </div>
    </div>
  )
}